import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { JwtPayload } from '../@types/jwtDocs';
import { fetchStrapiDocs } from '../api/strapi';

/**
 * Hook que escucha mensajes del sistema padre mediante postMessage
 * y actualiza el localStorage con los roles y logo del usuario
 */
const useParentAuth = () => {
  useEffect(() => {
    const getDefaultRol = async () => {
      try {
        const query = {
          filters: { Name: { $eq: 'General' } },
        };
        const data = await fetchStrapiDocs('/rols', query);
        const strapiRol = data.data[0];
        if (strapiRol) {
          const rolId = strapiRol.attributes.rolId || '';
          localStorage.setItem('clientRolsIds', JSON.stringify([rolId]));
          // Disparar evento personalizado para notificar a otros componentes
          window.dispatchEvent(new Event('clientRolsIdsUpdated'));
        }
        return strapiRol;
      } catch (error) {
        console.error('Error fetching default rol from Strapi:', error);
      }
    };

    const handleMessage = (event: MessageEvent) => {
      // Verifica el origen del mensaje para mayor seguridad
      // Nota: event.origin !== '' permite recibir mensajes de cualquier origen
      // Si necesitas restringir el origen, puedes especificarlo aquí
      if (event.origin !== '') {
        const { token } = event.data;
        if (token) {
          try {
            const decoded = jwtDecode<JwtPayload>(token);
            const roles = decoded.roles || [];
            const logo = decoded.logo || '';

            if (roles.length > 0) {
              localStorage.setItem('clientRolsIds', JSON.stringify(roles));
              localStorage.setItem('clientLogo', logo);
              // Disparar evento personalizado para notificar a otros componentes
              window.dispatchEvent(new Event('clientRolsIdsUpdated'));
            } else {
              getDefaultRol();
            }
          } catch (error) {
            console.error('Error decoding token:', error);
            getDefaultRol();
          }
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
};

export default useParentAuth;

